import { put, select, takeLatest } from 'redux-saga/effects'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import {
  setLocalNotifications,
  setLocalNotificationsToCancel,
  setSavedQuickActionButtons,
  setSavedQuickActionButtonsForNotification,
  setSelectedQuickActionButton,
} from '../store/quickActions.actions'
import { ILocalNotification, ISelectedQuickActionButton } from '../store/quickActions.types'

export function* setQuickActionButton() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const {
    selectedQuickActionButtonId,
    quickActionButtonRows,
    savedQuickActionButtonsForNotification,
    localNotifications,
    localNotificationsToCancel,
  } = quickActionsObject
  let selectedButton: ISelectedQuickActionButton = {}
  quickActionButtonRows.map((btn: any) => {
    const buttons = btn.buttons
    for (let i = 0; i < buttons.length; i++) {
      if (buttons[i].id == selectedQuickActionButtonId) {
        selectedButton = buttons[i]
        break
      }
    }
  })

  const MAX_32_BIT_INT = 2147483647
  const randomId = Math.floor(Math.random() * MAX_32_BIT_INT) + 1

  const newLocalNotification: ILocalNotification = {
    id: randomId,
    buttonId: selectedButton.props?.buttonId || 0,
    label: selectedButton.props?.label || '',
  }

  yield put(setSelectedQuickActionButton(selectedButton))
  yield put(setSavedQuickActionButtons(selectedButton))

  if (savedQuickActionButtonsForNotification.length) {
    const inAppNotifications = savedQuickActionButtonsForNotification.filter(
      (button: ISelectedQuickActionButton) => button?.props?.buttonId !== selectedQuickActionButtonId
    )

    const newLocalNotificationsToCancel: Array<ILocalNotification> = []

    const nonDuplicateLocalNotifications = localNotifications.filter((notification: ILocalNotification) => {
      const isDuplicate = notification.buttonId.toString() === selectedQuickActionButtonId
      if (isDuplicate) newLocalNotificationsToCancel.push(notification)

      return notification.buttonId.toString() !== selectedQuickActionButtonId
    })

    yield put(setSavedQuickActionButtonsForNotification([...inAppNotifications, selectedButton]))
    yield put(setLocalNotifications([...nonDuplicateLocalNotifications, newLocalNotification]))
    yield put(setLocalNotificationsToCancel([...localNotificationsToCancel, ...newLocalNotificationsToCancel]))
  } else {
    yield put(setSavedQuickActionButtonsForNotification([selectedButton]))
    yield put(setLocalNotifications([newLocalNotification]))
  }
}

export function* setQuickActionButtonSaga() {
  yield takeLatest([QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON_ID], setQuickActionButton)
}
